import { delay, firstValueFrom, map, of } from 'rxjs';
import { v4 } from 'uuid';
import { NodeConfiguration, NodeOptions } from '../type';
import { rootNodes } from './nodes';
import { dropAsyncValidatorMock, dropSyncValidatorMock } from './validators';

export function requestRootNodeDataMock(nodeId: string | number): Promise<NodeOptions> {
  return throttleRequest<NodeOptions>(rootNodes);
}

export function requestNodeDataMock(node: NodeConfiguration): Promise<NodeOptions> {
  return throttleRequest<NodeOptions>({
    currentNode: node,
    childNodes: Array(Math.round(Math.random() * 4))
      .fill(null)
      .map(() => {
        const uniqueId = v4();

        return {
          nodeId: uniqueId,
          nodeName: uniqueId,
          icon: 'ds-icon-resource_file',
          dropValidators: [dropSyncValidatorMock, dropAsyncValidatorMock],
        };
      }),
  });
}

export function requestPaginatedNodeDataMock(node: NodeConfiguration): Promise<NodeOptions> {
  const pageSize = 20;
  const page = node.page || 1;
  const startIndex = (page - 1) * pageSize;
  const totalItems = 30; // Total mock items available

  // implement hasMoreChildNodes
  const hasMoreChildNodes = totalItems > startIndex + pageSize;

  // Generate paginated items
  const childNodes = Array(Math.min(pageSize, totalItems - startIndex))
    .fill(null)
    .map((_, index) => {
      const itemNumber = startIndex + index + 1;
      const uniqueId = `${node.nodeId}-child-${itemNumber}`;

      return {
        nodeId: uniqueId,
        nodeName: `Item ${itemNumber}`,
        icon: 'ds-icon-resource_file',
        dropValidators: [dropSyncValidatorMock, dropAsyncValidatorMock],
      };
    });

  return throttleRequest<NodeOptions>({
    currentNode: node,
    childNodes: childNodes,
    hasMoreChildNodes,
  });
}

export function throttleRequest<T>(response: T) {
  return firstValueFrom(
    of(null).pipe(
      delay(100),
      map(() => response)
    )
  );
}
